module.exports = __webpack_public_path__ + "img/bg-gradiente.2c7f1166.svg";